<template>
    <div>
        <div class="list-group" v-if="!selecionado">
            <button type="button" class="list-group-item list-group-item-action" v-for="(item, iix) in lista_consultas" :key="iix" @click="dados = null; selecionado = item">
                {{ item.st_titulo }}
            </button>
        </div>

        <div v-else>

            <div class="alert alert-info d-flex justify-content-between">
                <div class="lead">
                    {{ selecionado.st_titulo }}
                </div>
                <div>
                    <button type="button" class="btn btn-sm btn-primary" @click="selecionado = null">
                        Voltar
                    </button>
                </div>
            </div>

            <div class="alert alert-secondary" style="white-space: pre-wrap;">{{ selecionado.st_instrucoes }}</div>

            <div class="card dashcard mb-3">
                <div class="card-body">
                    <div class="form-row"> 
                        <div class="col col-12 col-md-6">
                            <az-periodo v-model="filtros" :blockano="true" :sync="true" @sync="load()" />
                        </div>
                        <div class="col col-12 col-md-6">
                            <az-input   
                                icon="fa fa-search fa-fw"
                                v-model="filtros.pesquisa" 
                                placeholder="Pesquisa...">
                                <template v-slot:buttonposb>
                                    <print-export :dados="lista_resultados" :left="true" printid="impressao" />
                                </template>
                            </az-input>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="dados && dados.resultado && dados.resultado.length" id="impressao">

                <div>{{ lista_resultados.length }} / {{ dados.resultado.length }}</div>

                <table class="table table-sm table-hover bg-white table-bordered">
                    <thead>
                        <tr>
                            <th v-for="(coluna, icx) in dados.resultado[0]" :key="icx">
                                {{ icx ? icx.toUpperCase() : icx }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(linha, ilx) in lista_resultados" :key="ilx">
                            <td v-for="(coluna, icx) in linha" :key="icx">
                                <a href="#" @click.prevent="filtrar(coluna)" class="card-link">
                                    {{ coluna }}
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import AzPeriodo from '../shared/forms/AzPeriodo.vue';
import AzInput from '../shared/forms/AzInput.vue';
import PrintExport from '../shared/PrintExport.vue';

export default {
    data() {
        return {
            filtros: { 
                periodo: 'm',
                pesquisa: "", 
            },

            selecionado: null,
            dados: null,  
        }       
    },

    computed: { 
        lista_consultas: function () { 
            return this.$store.state.user.model.portal_consultas
                ? this.$store.state.user.model.portal_consultas
                : [];
        }, 

        lista_resultados: function () { 
            if ( !this.dados || !this.dados.resultado ) 
                return [];

            let reg = this.$util.getregex(this.filtros.pesquisa);

            return this.dados.resultado.filter(item => ( !this.filtros.pesquisa || reg.test(JSON.stringify(item)) ));
        }
    },

    components: {
        AzPeriodo,
        AzInput, 
        PrintExport, 
    },

    methods: {
        filtrar (texto) { 
            if ( this.filtros.pesquisa == '"' + texto + '"' ) { 
                this.filtros.pesquisa = "";
            } else { 
                this.filtros.pesquisa = '"' + texto + '"';
            }
        },

        load() {
            
            this.$util.load(this, { 
                service: 'laudos',
                func: 'info_portal', 
                parms: { 
                    id_portal_consulta: this.selecionado.id_portal_consulta,
                    ...this.filtros, 
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });
            
        }
    }
}
</script>
